import { Box, Text } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import { dateToString } from 'modules/core/lib/dates'
import { minutesToText } from 'modules/core/lib/duration'
import i18n from 'modules/core/lib/i18n'

interface DeleteShiftBlockProps {
  minutes: number
  date: string
  employeeName: string
  clockIn: string
  clockOut: string | undefined
  isBreak: boolean
  breakName?: string
}

const DeleteShiftBlock = ({
  minutes,
  date,
  employeeName,
  clockIn,
  clockOut,
  isBreak,
  breakName,
}: DeleteShiftBlockProps) => {
  const workedTime = minutesToText(minutes)

  return (
    <Box
      background="radicalRed200"
      paddingX="s16"
      paddingY="s24"
      borderRadius={{ all: 'abs012' }}
      gap="s8"
    >
      <Text size="200">
        {isBreak
          ? i18n.t('dashboard.todo.approvals.attendance.delete_break', {
              employee: employeeName ?? '',
              date: dateToString(moment(date ? String(date) : ''), 'ui_abbreviated_month_year'),
              clock_in: clockIn ?? '',
              clock_out: clockOut ?? '',
              break_name: breakName,
            })
          : i18n.t('dashboard.todo.approvals.attendance.delete_shift', {
              employee: employeeName ?? '',
              date: dateToString(moment(date ? String(date) : ''), 'ui_abbreviated_month_year'),
              clock_in: clockIn ?? '',
              clock_out: clockOut ?? '',
            })}
      </Text>
      <Text size="200">
        {i18n.t('dashboard.todo.approvals.attendance.worked_time', { workedTime })}
      </Text>
    </Box>
  )
}

export default DeleteShiftBlock
